import { useContext } from "react";
import { AccountContext } from "../contexts/AccountContext";

export function useAccount() {
  const context = useContext(AccountContext);

  return context;
}
